import React from 'react'
import PropTypes from 'prop-types'
import {useNavigate, useLocation} from 'react-router'

import withProviders from '../../../contexts/withProviders'
import {useRails} from '../../../contexts/rails'
import {
  useAcquisitionDecision,
  COMPLETE,
  DECISION_PENDING_ACKNOWLEDGED,
  DECISION_SUPPORTED,
} from '../../../hooks/useAcquisitionDecision'
import useFeatureFlags from '../../../hooks/useFeatureFlags'
import Onboarding from './Onboarding'
import Baseline from './Baseline'
import RailsFlashMessages from '../../../components/RailsFlashMessages'
import InvoiceEmailTemplateModals from '../../../components/InvoiceEmailTemplateModals'
import ConnectPayoutAccountModals from '../../../components/ConnectPayoutAccountModals'
import ConnectExpenseAccountModals from '../../../components/ConnectExpenseAccountModals'

const SHOW_DASHBOARD_STATES = [COMPLETE, DECISION_PENDING_ACKNOWLEDGED]

const DashboardSupplierScreen = ({
  flashMessages,
  supplierSetupTrackerState,
  signupProduct,
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const {authenticityToken} = useRails()

  const {data, isLoading} = useAcquisitionDecision(supplierSetupTrackerState)

  const {
    data: {features},
    loading: loadingFeatures,
  } = useFeatureFlags()

  const showBaseline =
    SHOW_DASHBOARD_STATES.includes(data.currentState) ||
    (!loadingFeatures &&
      features.getToKnowMarmalde &&
      data.currentState === DECISION_SUPPORTED)

  const onClose = () => {
    navigate('/dashboard')
  }

  const isModalOpen = (url) => location.pathname.startsWith(url)

  const isSetupTemplatesModalOpen = isModalOpen('/setup_templates')
  const isConnectPayoutAccountModalOpen = isModalOpen('/connect_payout_account')
  const isConnectExpenseAccountModalOpen = isModalOpen(
    '/connect_expense_account',
  )

  const displayChangeTemplatesModal =
    !loadingFeatures &&
    features?.invitePayersToMarmalade &&
    isSetupTemplatesModalOpen

  const displayConnectPayoutAccountModal = isConnectPayoutAccountModalOpen

  const displayConnectExpenseAccountModal = isConnectExpenseAccountModalOpen

  if (isLoading) {
    return null
  }

  return (
    <>
      <RailsFlashMessages flashMessages={flashMessages} />
      {showBaseline ? (
        <>
          <Baseline authenticityToken={authenticityToken} />
          {displayChangeTemplatesModal && (
            <InvoiceEmailTemplateModals
              isOpen={isSetupTemplatesModalOpen}
              onClose={onClose}
            />
          )}
          {displayConnectPayoutAccountModal && (
            <ConnectPayoutAccountModals
              isOpen={isConnectPayoutAccountModalOpen}
              onClose={onClose}
            />
          )}
          {displayConnectExpenseAccountModal && (
            <ConnectExpenseAccountModals
              isOpen={displayConnectExpenseAccountModal}
              onClose={onClose}
            />
          )}
        </>
      ) : (
        <Onboarding
          supplierSetupTrackerState={data.currentState}
          signupProduct={signupProduct}
        />
      )}
    </>
  )
}

DashboardSupplierScreen.defaultProps = {
  supplierSetupTrackerState: '',
}

DashboardSupplierScreen.propTypes = {
  flashMessages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  supplierSetupTrackerState: PropTypes.string,
  signupProduct: PropTypes.oneOf(['points_on_payments', 'payments_on_demand'])
    .isRequired,
}

export default withProviders(DashboardSupplierScreen)
